import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';
    const bodyWhereDamaged = getValueOrDefault(formConfig, formValues, 'bodyWhereDamaged');
    const claimTypes = getValueOrDefault(formConfig, formValues, 'claimType');
    const claimActivity = getValueOrDefault(formConfig, formValues, 'claimActivity').value;

    const getNextInjuryPage = (currentPageId: string) => {
        const injuryTypes = getValueOrDefault(formConfig, formValues, 'injuryType');

        switch (currentPageId) {
            case 'hvilke-skader':
                if (
                    injuryTypes.some((claimType: any) =>
                        [
                            'BONE',
                            'BONES',
                            'INJURY_AFTER_SURGERY',
                            'INJURY_AFTER_EXCESSIVE_LOAD',
                            'INJURY_AFTER_ILLNESS',
                            'SCAR',
                            'OTHER'
                        ].includes(claimType.value)
                    )
                ) {
                    return 'hvor-paa-kroppen';
                } else if (injuryTypes.some((claimType: any) => ['LIGAMENT_OR_KNEE'].includes(claimType.value))) {
                    return 'om-korsbaand-ledbaand';
                } else if (injuryTypes.some((claimType: any) => ['ACHILLES'].includes(claimType.value))) {
                    return 'om-akillessene';
                } else if (injuryTypes.some((claimType: any) => ['CRICK'].includes(claimType.value))) {
                    return 'om-ryggen-nakken';
                } else if (injuryTypes.some((claimType: any) => ['SLIPPED_DISC'].includes(claimType.value))) {
                    return 'om-discusprolaps';
                } else {
                    return 'tidligere-undersoegelse';
                }

            case 'skadede-kropsdele-overkrop':
                if (injuryTypes.some((claimType: any) => ['LIGAMENT_OR_KNEE'].includes(claimType.value))) {
                    return 'om-korsbaand-ledbaand';
                } else if (injuryTypes.some((claimType: any) => ['ACHILLES'].includes(claimType.value))) {
                    return 'om-akillessene';
                } else if (injuryTypes.some((claimType: any) => ['CRICK'].includes(claimType.value))) {
                    return 'om-ryggen-nakken';
                } else if (injuryTypes.some((claimType: any) => ['SLIPPED_DISC'].includes(claimType.value))) {
                    return 'om-discusprolaps';
                } else {
                    return 'tidligere-undersoegelse';
                }

            case 'skadede-kropsdele-underkrop':
                if (injuryTypes.some((claimType: any) => ['LIGAMENT_OR_KNEE'].includes(claimType.value))) {
                    return 'om-korsbaand-ledbaand';
                } else if (injuryTypes.some((claimType: any) => ['ACHILLES'].includes(claimType.value))) {
                    return 'om-akillessene';
                } else if (injuryTypes.some((claimType: any) => ['CRICK'].includes(claimType.value))) {
                    return 'om-ryggen-nakken';
                } else if (injuryTypes.some((claimType: any) => ['SLIPPED_DISC'].includes(claimType.value))) {
                    return 'om-discusprolaps';
                } else if (
                    injuryTypes.some((claimType: any) =>
                        [
                            'INJURY_AFTER_SURGERY',
                            'INJURY_AFTER_EXCESSIVE_LOAD',
                            'INJURY_AFTER_ILLNESS',
                            'OTHER'
                        ].includes(claimType.value)
                    )
                ) {
                    return 'beskriv-skaden';
                } else {
                    return 'tidligere-undersoegelse';
                }

            case 'om-korsbaand-ledbaand':
                if (injuryTypes.some((claimType: any) => ['ACHILLES'].includes(claimType.value))) {
                    return 'om-akillessene';
                } else if (injuryTypes.some((claimType: any) => ['CRICK'].includes(claimType.value))) {
                    return 'om-ryggen-nakken';
                } else if (injuryTypes.some((claimType: any) => ['SLIPPED_DISC'].includes(claimType.value))) {
                    return 'om-discusprolaps';
                }
                return 'tidligere-undersoegelse';
            case 'om-akillessene':
                if (injuryTypes.some((claimType: any) => ['CRICK'].includes(claimType.value))) {
                    return 'om-ryggen-nakken';
                } else if (injuryTypes.some((claimType: any) => ['SLIPPED_DISC'].includes(claimType.value))) {
                    return 'om-discusprolaps';
                }
                return 'tidligere-undersoegelse';
            case 'om-ryggen-nakken':
                if (injuryTypes.some((claimType: any) => ['SLIPPED_DISC'].includes(claimType.value))) {
                    return 'om-discusprolaps';
                }
                return 'tidligere-undersoegelse';

            case 'om-discusprolaps':
                return 'tidligere-undersoegelse';
            case 'beskriv-skaden':
                return 'tidligere-undersoegelse';
        }
    };

    switch (curPageId) {
        case 'godt-at-vide':
            return 'samtykke';

        case 'samtykke':
            return 'hvem';
        // ==========================
        // Step 1: About the claimant
        // ==========================
        case 'hvem':
            if (getValueOrDefault(formConfig, formValues, 'claimant').value === 'CHILD') {
                return 'om-barnet';
            }
            if (getValueOrDefault(formConfig, formValues, 'claimant').value === 'OTHER_CLAIMANT') {
                return 'om-anden-person';
            }

            return 'dato';

        case 'om-barnet':
            return 'dato';

        case 'om-anden-person':
            return 'dato';

        // ========================
        // Step 2: About the claim
        // ========================
        case 'dato':
            return 'tidspunkt';

        // page 3
        case 'tidspunkt':
            return 'hvor-skete-skaden';

        // page 7 moved
        case 'hvor-skete-skaden':
            const lossLocation = getValueOrDefault(formConfig, formValues, 'lossLocation');
            if (lossLocation.value === 'HOME') {
                return 'hvad-er-skadet';
            } else if (lossLocation.value === 'DAYCARE') {
                return 'om-stedet';
            } else if (lossLocation.value === 'WORK') {
                return 'om-ansaettelse';
            }
            return 'hvad-er-skadet';

        case 'om-stedet':
            return 'hvad-er-skadet';

        case 'om-ansaettelse':
            return 'hvad-er-skadet';

        // page 4
        case 'hvad-er-skadet':
            if (claimTypes.some((claimType: any) => claimType.value === 'BODY')) {
                return 'undersoegt-eller-behandlet';
            } else if (claimTypes.some((claimType: any) => claimType.value === 'TEETH')) {
                return 'taender';
            }
            return 'resume'; //update

        // page 4A
        case 'undersoegt-eller-behandlet':
            const reportClaimAnyway = getValueOrDefault(formConfig, formValues, 'reportClaimAnyway');

            if (
                getValueOrDefault(formConfig, formValues, 'existingExamination').value === 'no' &&
                reportClaimAnyway.some((reportAnyway: any) => reportAnyway.value === 'yes')
            ) {
                return 'hvilke-skader';
            }

            return 'hvor-blev-du-undersoegt';

        case 'hvor-blev-du-undersoegt':
            return 'hvilke-skader';

        // page 4B
        case 'taender':
            return 'oplysninger-om-tandlaege';

        case 'oplysninger-om-tandlaege':
            return 'vaelg-hvilke-taender';

        case 'vaelg-hvilke-taender':
            nextPage = 'hvordan-skete-skaden';
            break;

        // page 5
        case 'hvilke-skader':
            nextPage = getNextInjuryPage(curPageId);
            break;

        case 'hvor-paa-kroppen':
            if (bodyWhereDamaged.value === 'UPPER_BODY') {
                return 'skadede-kropsdele-overkrop';
            } else if (bodyWhereDamaged.value === 'LOWER_BODY') {
                return 'skadede-kropsdele-underkrop';
            }
            return 'skadede-kropsdele-overkrop';

        case 'skadede-kropsdele-overkrop':
            if (['LOWER_BODY', 'UPPER_LOWER_BODY'].includes(bodyWhereDamaged.value)) {
                nextPage = 'skadede-kropsdele-underkrop';
            } else {
                nextPage = getNextInjuryPage(curPageId);
            }
            break;

        case 'skadede-kropsdele-underkrop':
            nextPage = getNextInjuryPage(curPageId);
            break;

        case 'om-korsbaand-ledbaand':
            nextPage = getNextInjuryPage(curPageId);
            break;

        case 'om-akillessene':
            nextPage = getNextInjuryPage(curPageId);
            break;

        case 'om-ryggen-nakken':
            nextPage = getNextInjuryPage(curPageId);
            break;

        case 'om-discusprolaps':
            nextPage = getNextInjuryPage(curPageId);
            break;

        case 'beskriv-skaden':
            nextPage = getNextInjuryPage(curPageId);
            break;

        // page 6
        case 'tidligere-undersoegelse':
            if (claimTypes.some((claimType: any) => ['TEETH'].includes(claimType.value))) {
                return 'taender';
            } else {
                return 'hvordan-skete-skaden';
            }

        // page 8
        case 'hvordan-skete-skaden':
            if (claimActivity === 'TRAFFIC') return 'trafik';
            if (
                ['SPORT', 'ASSAULT', 'FIREWORKS', 'CHEWING', 'ANIMAL', 'MACHINE', 'PLAY', 'RUNNING', 'OTHER'].includes(
                    claimActivity
                )
            )
                return 'oplysninger-om-skaden';

            return 'resume';

        case 'oplysninger-om-skaden':
            if (claimActivity === 'TRAFFIC') return 'politi';

            return 'paavirkning';

        case 'trafik':
            const trafficClaimReason = getValueOrDefault(formConfig, formValues, 'trafficClaimReason');

            if (trafficClaimReason.value === 'COLLISION') {
                return 'modpart';
            } else {
                return 'oplysninger-om-skaden';
            }

        case 'modpart':
            const trafficCounterParty = getValueOrDefault(formConfig, formValues, 'trafficCounterParty');
            if (trafficCounterParty.value === 'YES') {
                return 'oplysninger-om-modpart';
            }
            return 'oplysninger-om-skaden'; //oplysninger-om-skaden-2

        case 'oplysninger-om-modpart':
            return 'oplysninger-om-skaden';

        case 'politi':
            return 'paavirkning';

        case 'paavirkning':
            const alcohol = getValueOrDefault(formConfig, formValues, 'alcohol');

            if (alcohol.value === 'YES') {
                return 'hvilken-paavirkning';
            }
            return 'dokumentation';

        case 'hvilken-paavirkning':
            return 'dokumentation';

        // =====================
        // Step 3: Documentation
        // =====================
        case 'dokumentation':
            return 'sygeforsikring';

        // =====================
        // Step 4: About you
        // =====================
        case 'sygeforsikring':
            nextPage = 'anden-ulykkesforsikring';
            break;
        case 'anden-ulykkesforsikring':
            nextPage = 'anden-forsikring';

            if (getValueOrDefault(formConfig, formValues, 'hasOtherHealthInsurance').value === 'yes') {
                nextPage = 'om-forsikringsselskabet';
            }

            break;
        case 'om-forsikringsselskabet':
            nextPage = 'anden-forsikring';
            break;
        case 'anden-forsikring':
            nextPage = 'om-dig';

            if (getValueOrDefault(formConfig, formValues, 'hasOtherInsuranceWithSimilarCoverage').value === 'yes') {
                nextPage = 'hvilket-selskab';
            }

            break;
        case 'hvilket-selskab':
            nextPage = 'andre-oplysninger';

            const otherInsuranceProvider = getValueOrDefault(formConfig, formValues, 'otherInsuranceProvider').value;
            if (otherInsuranceProvider === 'insuranceCompany') {
                nextPage = 'om-forsikringsselskabet-1';
            } else if (otherInsuranceProvider === 'bank') {
                nextPage = 'om-banken';
            }

            break;
        case 'om-forsikringsselskabet-1':
            nextPage = 'om-dig';
            break;
        case 'om-banken':
            nextPage = 'om-dig';
            break;
        case 'andre-oplysninger':
            nextPage = 'om-dig';
            break;

        case 'om-dig':
            return 'resume';

        // undefined means it is the last page
        case 'resume':
            return undefined;

        default:
            throw new Error('getPagePrev: Unknown page: ' + curPageId);
    }
    return nextPage;
};
